module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_9006.b3be6191.png";